import * as z from 'zod';

export const CitySchema = z.object({
    id: z.number().int(),
    name: z.string(),
});

export type City = z.infer<typeof CitySchema>;
